import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchYears'
})

export class SearchYearsPipe implements PipeTransform {

  transform(pipeData, {currentYear, activeFestival, currentFestival}): any {
    if (activeFestival == currentFestival) {
      var thisYear = new Date().getFullYear();
      return pipeData.filter(eachItem => {
        if (eachItem['fields']['festival_year']) {
          return (
            eachItem['fields']['festival_year'].includes(thisYear)
          )
        }
      });
    } else if (currentYear != 'YEAR FEATURED') {
      return pipeData.filter(eachItem => {
        if (eachItem['fields']['festival_year']) {
          return (
            eachItem['fields']['festival_year'].includes(currentYear)
          )
        }
      });
    } else {
      return pipeData
    }
  }

}